<template>
  <div class="list-header">
    <div class="list-header-operate">
      <div class="list-header-operate-title">
        <div class="speed_logo" :class="{'speed_logo-en': $i18n.locale === 'en'}"></div>
      </div>

      <div class="tc-g cos-header-operate no-drag-bar">
        <div class="divider"></div>
        <!-- 语言切换按钮 -->
        <div class="tc-g-u">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div class="language-switch" @click="toggleLanguage">
              {{currentLanguage === 'zh' ? '中文' : 'EN'}}
            </div>
            <template slot="popup">{{currentLanguage === 'zh' ? $t('cos.switch_to_english') : $t('cos.switch_to_chinese')}}</template>
          </qc-bubble>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      currentLanguage: localStorage.getItem('locale') || this.$i18n.locale || 'zh',
    };
  },
  methods: {
    // 切换语言方法
    toggleLanguage() {
      const newLocale = this.currentLanguage === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLocale;
      this.currentLanguage = newLocale;
      // 保存语言设置到本地存储
      localStorage.setItem('locale', newLocale);
      // 显示切换成功提示
      // utils.tips.success(newLocale === 'zh' ? '已切换到中文' : 'Switched to English');
    },
  },
};
</script>

<style scoped lang="scss">
// 语言切换按钮样式
.language-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  color: #666;
  border-radius: 4px;
  transition: all 0.3s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #333;
  }
}
</style>
